import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;

const Dropdown = ({
  input,
  label,
  options,
  required,
  customVal,
  receiveValue,
  error,
  meta,
  ...props
}) => {
  const { value, onChange } = input || {};
  const { t } = useTranslation();

  const handleChange = (event) => {
    input.onChange(value);
    // onChange(event.target.value);
  };


  return (
    <div>
      <Content>
        <Typography required={required} color="#666666">
          {label} {required ? "*" : ""}
        </Typography>
      </Content>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={onChange ? onChange : handleChange}
          displayEmpty
          size="small"
          error={meta && meta.touched && meta.error && error}
          {...input}
          {...props}
        >
          <MenuItem>
            {t("Select")}
          </MenuItem>
          {options?.map((option) => (
            <MenuItem
              key={option.value}
              value={customVal ? option : option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {meta && meta.touched && meta.error ? (
          <Typography color="red" fontSize={".8rem"} align={"center"}>
            {error}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    </div>
  );
};

export default Dropdown;
